import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=b6ce40a4&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=b6ce40a4&prod&lang=css"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=b6ce40a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ce40a4",
  null
  
)

export default component.exports